export default __webpack_public_path__ + "static/feature2-1b774c60c9457675e595a522504755f5.jpg";